<template>
  <div v-if="props.files.length > 0" class="document-list">
    <ul>
      <RelatedDocTabRow v-for="file in files" :key="file.fileSn" :file="file" />
    </ul>
  </div>
  <div v-else class="c-no-data-box type-no-line">
    <div class="icon-box">
      <i class="c-icon icon-nodata size-large"></i>
    </div>
    <p class="text">등록된 문서가 없습니다.</p>
  </div>
</template>
<script setup>
import { computed, defineProps, onMounted } from "vue";
import RelatedDocTabRow from "@/components/paintpro/prod/relatedDocTabRow.vue";

const props = defineProps({
  files: {
    type: Array,
    required: true,
  },
});

onMounted(() => {});

const files = computed(() => {
  const _files = [...props.files];

  _files.forEach((item) => {
    item.goodsFileSeCdSize = 1;
    item.goodsFileSeCdShowYn = true;
  });

  for (let i = 0; i < _files.length; i++) {
    if (_files[i].goodsFileSeCdShowYn && _files.length > i) {
      for (let j = i + 1; j < _files.length; j++) {
        if (_files[i].goodsFileSeCd === _files[j].goodsFileSeCd) {
          _files[i].goodsFileSeCdSize += 1;
          _files[j].goodsFileSeCdShowYn = false;
          _files[j].goodsFileSeCdSize = 0;
        }
      }
    }
  }

  return _files;
});
</script>
